/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiConversationTractiveDiscountCodeRetrieve2Type =
  (typeof ApiConversationTractiveDiscountCodeRetrieve2Type)[keyof typeof ApiConversationTractiveDiscountCodeRetrieve2Type];

export const ApiConversationTractiveDiscountCodeRetrieve2Type = {
  cmr: 'cmr',
  member_profile: 'member_profile',
} as const;
